import axios from 'axios';

const dynaltUrl = 'https://dynalt2.lvshuimeng.com' // 绿水梦云组态域名

const key = "89814090";

export function dynalt_Create(data) {
  return axios({
    method: "post",
    baseURL: dynaltUrl,
    url: "/dynalt2/create",
    data: data,
    params: { key }
  })
}

export function dynalt_List() {
  return axios({
    method: "get",
    baseURL: dynaltUrl,
    url: "/dynalt2/list",
    params: { key }
  })
}

export function dynalt_Update(data) {
  return axios({
    method: "post",
    baseURL: dynaltUrl,
    url: "/dynalt2/update",
    data: data,
    params: { key }
  })
}

export function dynalt_Delete(id) {
  return axios({
    method: "get",
    baseURL: dynaltUrl,
    url: "/dynalt2/delete",
    params: { id: id, key }
  })
}

export function dynalt_Upload(param) {
  param.append("key", key);
  return axios.post(
    dynaltUrl + '/dynalt2/upload',
    param, {
      headers: { "Content-Type": "multipart/form-data" },
    })
}

export function dynalt_Retrieve(id) {
  return axios({
    method: "get",
    baseURL: dynaltUrl,
    url: "/dynalt2/retrieve",
    params: { id, key: "89814090", key }
  })
}

export function dynalt_Config(data) {
  return axios({
    method: "post",
    baseURL: dynaltUrl,
    url: "/dynalt2/config",
    data: data,
    params: { key }
  })
}


export function dynalt_Material_Label() {
  return axios({
    method: "get",
    baseURL: dynaltUrl,
    url: "/dynalt2/material/label",
    params: { key }
  })
}

export function dynalt_Material_List(label) {
  return axios({
    method: "get",
    baseURL: dynaltUrl,
    url: "/dynalt2/material/list",
    params: { label: label, key }
  })
}

export function dynalt_Material_Save(url) {
  return axios({
    method: "get",
    baseURL: dynaltUrl,
    url: "/dynalt2/material/save",
    params: { url: url, key }
  })
}

export function dynalt_Material_Private() {
  return axios({
    method: "get",
    baseURL: dynaltUrl,
    url: "/dynalt2/material/private",
    params: { key }
  })
}

export function dynalt_Material_Delete(url) {
  return axios({
    method: "get",
    baseURL: dynaltUrl,
    url: "/dynalt2/material/delete",
    params: { url: url, key }
  })
}

export function dynalt_Material_Upload(param) {
  param.append("key", key);
  return axios.post(
    dynaltUrl + '/dynalt2/material/upload',
    param, {
      headers: { "Content-Type": "multipart/form-data" },
    })
}

export function dynalt_Material_Cover(param) {
  param.append("key", key);
  return axios.post(
    dynaltUrl + '/dynalt2/material/cover',
    param, {
      headers: { "Content-Type": "multipart/form-data" },
    })
}

export function dynalt_Image_Upload(data) {
  return axios({
    method: "post",
    baseURL: dynaltUrl,
    url: "/dynalt2/image/upload",
    data: data,
    params: { key }
  })
}

export function dynalt_Image_List(id) {
  return axios({
    method: "get",
    baseURL: dynaltUrl,
    url: "/dynalt2/image/list",
    params: { id, key }
  })
}

export function dynalt_Image_Delete(id, url) {
  return axios({
    method: "get",
    baseURL: dynaltUrl,
    url: "/dynalt2/image/delete",
    params: { id, url, key }
  })
}